module.exports = __webpack_public_path__ + "static/media/edit.e1eef28f.svg";